export const columnDefSuppressFloatingFilterButton = {
  suppressFloatingFilterButton: true,
};
